module.exports = __webpack_public_path__ + "img/des_tuse_4.12110be0.jpg";